(function () {
  var MIN = 990;
  var MAX = 1366;

  function isAppleTablet() {
    if (navigator.maxTouchPoints < 2) return false;
    var ua = navigator.userAgent;
    if (/iPad/i.test(ua)) return true;
    // iPadOS 13+ reports as Macintosh with touch
    return /Macintosh/i.test(ua) && navigator.maxTouchPoints > 1;
  }

  function isTouchTablet() {
    return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
  }

  function shouldUseTabletUI() {
    var w = window.innerWidth;
    if (w < MIN || w > MAX) return false;
    return isTouchTablet() || isAppleTablet();
  }

  function syncTabletUI() {
    document.documentElement.classList.toggle('artbeat-tablet-ui', shouldUseTabletUI());
  }

  syncTabletUI();

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncTabletUI, 100);
  });
  window.addEventListener('orientationchange', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(syncTabletUI, 150);
  });
})();
